<sm-card [showSeperator]="false" [isFolder]="folder" [oneTabMode]="true" (click)="plusCardClicked()">
  <div class="plus-card-body d-flex pointer">
    <div class="al-icon al-ico-plus al-color blue-400 plus-icon xl"></div>
  </div>
</sm-card>
